export default function salesforceIframeSetup(iframeId) {
	try {
		const data = window.dataLayer?.[0];
		if (!data || !data.navigation || !data.userInfo) {
			return;
		}

		const { countryISO, pageLanguage } = data.navigation;
		const { customerType } = data.userInfo;
		const enviromentType = data.environment;

		const iframe = document.getElementById(iframeId);
		const dataSrc = iframe?.getAttribute('data-src');
		const formType = iframe?.getAttribute('data-form-type');

		if (!iframe || !dataSrc || !formType) return;

		const url = `${dataSrc}?countryCode=${countryISO}&languageCode=${pageLanguage}&customerType=${customerType}&sourceType=${formType}&environment=${enviromentType}`;

		return fetch(url)
			.then(res => {
				if (!res.ok) return;
				return res.text();
			})
			.then(html => {
				if (!html) return;
				iframe.srcdoc = html;
			})
			.catch(() => {
				// Fail silently
			});
	} catch {
		// Fail silently
	}
}
